import React, { useState, useEffect } from "react";
import EventForm from "../../components/events/EventForm";
import { ChevronLeft, Loader2 } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useEvents } from "../../services/admin/EventsServices";

export default function EditEventPage() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { fetchEventById, updateEvent, loading } = useEvents();
    const [event, setEvent] = useState(null);
    const [isFetching, setIsFetching] = useState(true);


    useEffect(() => {
        const loadEvent = async () => {
            try {
                const data = await fetchEventById(id);
                if (data) {
                    setEvent({
                        ...data
                    });
                } else {
                    navigate("/admin/events");
                }
            } catch (err) {
                console.error("Failed to load event", err);
            } finally {
                setIsFetching(false);
            }
        };
        loadEvent();
    }, [id, fetchEventById, navigate]);

    const handleUpdate = async (data) => {
        const result = await updateEvent(id, data);
        if (result && result.status === "success") {
            navigate("/admin/events");
        }
    };

    if (isFetching || !event) {
        return (
            <div className="flex h-screen items-center justify-center">
                <Loader2 className="animate-spin text-jazz-brown" size={32} />
            </div>
        );
    }

    return (
        <>
            <div className="p-6 lg:p-10 max-w-5xl mx-auto">
                {/* Navigation Header */}
                <button
                    onClick={() => navigate("/admin/events")}
                    className="flex items-center gap-2 text-black dark:text-white/40 hover:text-black/70 dark:hover:text-white transition-colors text-xs font-bold tracking-widest uppercase mb-6"
                >
                    <ChevronLeft size={16} /> BACK TO EVENTS
                </button>

                <div className="mb-10">
                    <h1 className="text-3xl lg:text-4xl font-normal text-black dark:text-white mb-2" style={{ fontFamily: "Playfair Display, serif" }}>
                        Edit Event
                    </h1>
                    <p className="text-black dark:text-white/50 text-sm italic font-serif">
                        Modify the details for "{event.title}".
                    </p>
                </div>

                {/* Form */}
                <EventForm initialData={event} onSubmit={handleUpdate} isEditing={true} isLoading={loading} />
            </div>
        </>
    );
}
